import { getLanguage } from '@app/i18n';

export const SET_SHOW_LOCALIZATION_SETTINGS =
  'iron/localization/SET_SHOW_LOCALIZATION_SETTINGS';
export const SET_LANGUAGE = 'iron/localization/SET_LANGUAGE';
export const SET_PREVIOUS_URL = 'iron/localization/SET_PREVIOUS_URL';
export const SET_SAVED_LANGUAGE = 'iron/localization/SET_SAVED_LANGUAGE';
export const SET_SELECTED_REGION = 'iron/localization/SET_SELECTED_REGION';
export const SET_LOCALIZATION_SETTINGS =
  'iron/localization/SET_LOCALIZATION_SETTINGS';

export const GET_COUNTRIES = 'iron/localization/FETCH_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'iron/localization/GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'iron/localization/GET_COUNTRIES_ERROR';

export const setShowLocalizationSettings = (showLocalizationSettings) => ({
  type: SET_SHOW_LOCALIZATION_SETTINGS,
  payload: {
    showLocalizationSettings,
  },
});

export const setLocalizationSettings = (settings) => ({
  type: SET_LOCALIZATION_SETTINGS,
  payload: settings,
});

export const setLanguage = ({
  language,
  url,
  code,
  urlPrefix,
  currency = null,
  skipEffect = false,
}) => ({
  type: SET_LANGUAGE,
  payload: {
    language,
    url,
    code,
    urlPrefix,
    currency,
  },
  skipEffect,
});

export const setLanguageByRegion = (regionCode: string) => {
  const selectedLanguage = getLanguage(regionCode, 'regExp');

  return setLanguage({
    language: selectedLanguage.display,
    url: selectedLanguage.url,
    code: selectedLanguage.value,
    urlPrefix: selectedLanguage.urlPrefix,
  });
};

export const setPreviousUrl = (previousUrl) => ({
  type: SET_PREVIOUS_URL,
  payload: {
    previousUrl,
  },
});

export const setSavedLanguage = (savedLanguage) => ({
  type: SET_SAVED_LANGUAGE,
  payload: {
    savedLanguage,
  },
});

export const setSelectedRegion = ({ selectedRegion }) => ({
  type: SET_SELECTED_REGION,
  payload: {
    selectedRegion,
  },
});

export const getCountries = () => ({
  type: GET_COUNTRIES,
  payload: {
    loading: true,
    error: null,
  },
});

export const getCountriesSuccess = (allCountries) => ({
  type: GET_COUNTRIES_SUCCESS,
  payload: {
    loading: false,
    allCountries,
    error: null,
  },
});

export const getCountriesError = (error) => ({
  type: GET_COUNTRIES_ERROR,
  payload: {
    loading: false,
    error,
  },
});
